var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideMenuAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.69995 10.2C5.69995 10.3657 5.83427 10.5 5.99995 10.5C6.16564 10.5 6.29995 10.3657 6.29995 10.2V6.29995H10.2C10.3657 6.29995 10.5 6.16564 10.5 5.99995C10.5 5.83427 10.3657 5.69995 10.2 5.69995H6.29995V1.8C6.29995 1.63431 6.16564 1.5 5.99995 1.5C5.83427 1.5 5.69995 1.63431 5.69995 1.8V5.69995H1.8C1.63431 5.69995 1.5 5.83427 1.5 5.99995C1.5 6.16564 1.63431 6.29995 1.8 6.29995H5.69995V10.2Z",
    fill: "#5B5C5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideMenuAdd);
export default __webpack_public_path__ + "static/media/sideMenuAdd.42888846823b307b94dd265a0fbbe52f.svg";
export { ForwardRef as ReactComponent };